import React, { memo } from 'react';

interface MeetingActionsProps {
  selectedCount: number;
  onAddToMeeting: (field: 'required' | 'optional') => void;
}

const MeetingActions = memo<MeetingActionsProps>(({ selectedCount, onAddToMeeting }) => {
  return (
    <div className="flex">
      <div className="flex flex-col sm:flex-row sm:items-center gap-2 min-w-0">
        <span className="text-sm text-gray-600 whitespace-nowrap">
          {selectedCount} selected
        </span>
        <div className="flex gap-1 min-w-0">
          <button
            onClick={() => onAddToMeeting('required')}
            disabled={selectedCount === 0}
            className={`px-2 py-1 text-xs rounded transition-colors whitespace-nowrap flex-shrink-0 ${
              selectedCount > 0
                ? 'bg-blue-500 text-white hover:bg-blue-600 hover:shadow-md'
                : 'bg-gray-300 text-gray-500 cursor-not-allowed'
            }`}
          >
            Add to Required
          </button>
          <button
            onClick={() => onAddToMeeting('optional')}
            disabled={selectedCount === 0}
            className={`px-2 py-1 text-xs rounded transition-colors whitespace-nowrap flex-shrink-0 ${
              selectedCount > 0
                ? 'bg-blue-500 text-white hover:bg-blue-600 hover:shadow-md'
                : 'bg-gray-300 text-gray-500 cursor-not-allowed'
            }`}
          >
            Add to Optional
          </button>
        </div>
      </div>
    </div>
  );
});

MeetingActions.displayName = 'MeetingActions';

export default MeetingActions;

